import { ViewModel,View, ObservableArray } from "binder"
import  { StartupNotificationsView } from "./startupNotifications-view"
import { WindowViewModel } from "../../windowContainer/windowContainer-viewModel";
import { translate } from "src/common/utilities";

export class StartupNotificationsViewModel extends WindowViewModel{
    public getTitle(): string {
        return translate("startupNotifications-viewModel.userMessages",{});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<notification>();
    }
    GetDefaultView(): View <ViewModel> {
        return new StartupNotificationsView();
    }
    public getTypeId(): string {
        return "VM-847992F7-0B9E-4F8E-8928-F7B0128A641A"
    }
    public set items(v: ObservableArray<notification>) { this._items = v; } public get items(): ObservableArray<notification> { return this._items;} private _items: ObservableArray<notification>;
    
    show(items:{header:string,body:string}[]){
        this.items.update(...items.map(x=>{
            let r = new notification(this);
            r.header = x.header;
            r.body = x.body;
            r.isExpanded = false;
            return r;
        }));
        let firstItem = this.items.at(0)
        if(firstItem)
            firstItem.isExpanded = true;
    }
}

export class notification extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set header(v: string) { this._header = v; } public get header(): string { return this._header;} private _header: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body;} private _body: string;
    public set isExpanded(v: boolean) { this._isExpanded = v; } public get isExpanded(): boolean { return this._isExpanded;} private _isExpanded: boolean;
    
}